import { render, staticRenderFns } from "./WalletViewWalletInfoCard.vue?vue&type=template&id=36b72755"
import script from "./WalletViewWalletInfoCard.vue?vue&type=script&lang=js"
export * from "./WalletViewWalletInfoCard.vue?vue&type=script&lang=js"
import style0 from "./WalletViewWalletInfoCard.vue?vue&type=style&index=0&id=36b72755&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports